/**
 * Canonical SWR Keys for Dock Operations
 * Single Source of Truth to ensure mutations are deterministic across Board, Schedule, and Map.
 */

// Key for the main Dock Board (Summary + Grid + Map)
export const dockBoardKey = () => '/api/docks/board';

// Key for a specific Dock Schedule (Drawer)
export const dockScheduleKey = (dockId: string) => `/api/docks/${dockId}/schedule`;

// Helper to mutate both views after an action
import { mutate } from 'swr';
import { format } from 'date-fns';

export const refreshDockViews = async (dockId: string) => {
    const today = format(new Date(), 'yyyy-MM-dd');
    // Mutate the board (grid/map)
    await mutate(dockBoardKey());
    // Mutate the specific schedule viewed
    // Note: The drawer often appends ?date=... so we might need to be fuzzy or exact.
    // The drawer typically uses: /api/docks/${dockId}/schedule?date=${today}
    // We should ideally match that parameter.

    // We will mutate the EXACT key used by the drawer for TODAY.
    // If the user is looking at a different date, we might miss it, but operational actions are usually for "today".
    await mutate(`${dockScheduleKey(dockId)}?date=${today}`);
};
